export const OTHER_DETAILS = 'other-details';
export const VENDOR_INFORMATION = 'vendor-information';
export const VENDOR_ADDRESS = 'vendor-address';
export const STATION_TYPE = 'station-type';
export const STATION_DETAILS = 'station-details';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const ESL_LICENCE = [
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-used-of-system',
                label: 'Proposed use of System/Equipment',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12
            },
            {
                id: 'do-you-have-any-equipment-vendor',
                label: 'Do you have any equipment vendor?',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: VENDOR_INFORMATION,
        sectionName: 'Vendor Information',
        fieldList: [
            {
                id: 'company-name',
                label: 'Company Name',
                type: 'text'
            },
            {
                id: 'vendor-dealers-licence-number',
                label: "Vendor Dealer's Licence Number",
                type: 'text'
            },
            {
                id: 'contact-person',
                label: 'Contact Person Name (Optional)',
                type: 'text'
            },
            {
                id: 'contact-number',
                label: 'Contact Number (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_ADDRESS,
        sectionName: 'Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_TYPE,
        sectionName: '',
        fieldList: [
            {
                id: 'station-type',
                label: 'Station Type',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_DETAILS,
        sectionName: '',
        fieldList: [
            {
                id: 'station-tabs',
                label: '',
                type: 'tab',
                span: 12,
                tabs: [
                    {
                        id: '1',
                        label: 'Fixed Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'call-sign',
                                        label: 'Call Sign',
                                        type: 'text'
                                    },
                                    {
                                        id: 'station-name',
                                        label: 'Station Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'location-of-station',
                                        label: 'Location of Station',
                                        type: 'text'
                                    },
                                    {
                                        id: 'address',
                                        label: 'Address',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'building-name',
                                        label: 'Building Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'postal-code',
                                        label: 'Postal Code',
                                        type: 'text'
                                    },
                                    {
                                        id: 'street-name',
                                        label: 'Street Name',
                                        type: 'text'
                                    },
                                    {
                                        id: 'block-house-no',
                                        label: 'Block/House No.',
                                        type: 'text'
                                    },
                                    {
                                        id: 'floor-level',
                                        label: 'Floor/Level (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'unit',
                                        label: 'Unit (Optional)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude (N)',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude (E)',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: '',
                                        label: '',
                                        type: 'text'
                                    },
                                    {
                                        id: 'building-height-m',
                                        label: 'Building Height (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-effective-height-m-above-ground-level',
                                        label: 'Antenna Effective Height (m) (above ground level)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'elevation-above-mean-sea-level',
                                        label: 'Elevation Above Mean Sea Level (m)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'transportable',
                                        label: 'Transportable',
                                        type: 'text'
                                    },
                                    {
                                        id: 'radio-equipment-information',
                                        label: 'Radio Equipment Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'manufacturer-transmitter',
                                        label: 'Manufacturer (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'manufacturer-receiver',
                                        label: 'Manufacturer (Receiver)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model-transmitter',
                                        label: 'Model (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model-receiver',
                                        label: 'Model (Receiver)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'output-power-w-transmitter',
                                        label: 'Output Power (W) (Transmitter)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-information',
                                        label: 'Antenna Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'antenna-manufacturer',
                                        label: 'Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'polarization',
                                        label: 'Polarization',
                                        type: 'text'
                                    },
                                    {
                                        id: 'antenna-displacement-from-station',
                                        label: 'Antenna Displacement From Station',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'north-latitude-displacement',
                                        label: 'North Latitude Displacement',
                                        type: 'text'
                                    },
                                    {
                                        id: 'east-longitude-displacement',
                                        label: 'East Longitude Displacement',
                                        type: 'text'
                                    },
                                    {
                                        id: 'gain-db',
                                        label: 'Gain (dB)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'filter-information',
                                        label: 'Filter Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'filter-manufacturer',
                                        label: 'Manufacturer',
                                        type: 'text'
                                    },
                                    {
                                        id: 'model',
                                        label: 'Model',
                                        type: 'text'
                                    },
                                    {
                                        id: 'insertion-loss-db',
                                        label: 'Insertion Loss (db)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'tuned-frequency-mhz',
                                        label: 'Tuned Frequency (MHz)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-information',
                                        label: 'Feeder Information',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'feeder-line-type-transmit',
                                        label: 'Feeder Line Type (Transmit)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-type-receive',
                                        label: 'Feeder Line Type (Receive)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-length-m-transmit',
                                        label: 'Feeder Line Length (M) (Transmit)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-length-m-receive',
                                        label: 'Feeder Line Length (M) (Receive)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-loss-db-transmit',
                                        label: 'Feeder Line Loss (dB) (Transmit)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'feeder-line-loss-db-receive',
                                        label: 'Feeder Line Loss (dB) (Receive)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'frequency-and-emission-class-information',
                                        label: 'Frequency Information',
                                        type: 'subsection',
                                        fieldlist: [
                                            {
                                                id: 'frequency-and-emission-class-information-table',
                                                label: '',
                                                type: 'table',
                                                subFields: [
                                                    {
                                                        id: 'desired-frequency-mhz-from-tx',
                                                        header: 'Desired Frequency (MHz) - From (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-to-tx',
                                                        header: 'Desired Frequency (MHz) - To (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-from-rx',
                                                        header: 'Desired Frequency (MHz) - From (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-to-rx',
                                                        header: 'Desired Frequency(MHz) - To (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-bandwidth-khz-tx',
                                                        header: 'Desired Bandwidth (kHz) (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-bandwidth-khz-rx',
                                                        header: 'Desired Bandwidth (kHz) (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'start-time',
                                                        header: 'Start Time',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'stop-time',
                                                        header: 'Stop Time',
                                                        type: 'text'
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'frequency-and-emission-class-information-accordion',
                                                label: '',
                                                type: 'accordion',
                                                subFields: [
                                                    {
                                                        id: 'emission-class-transmit',
                                                        label: 'Emission Class - Transmit',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'emission-class-receive',
                                                        label: 'Emission Class - Receive',
                                                        type: 'text'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: '2',
                        label: 'Mobile Station Details',
                        type: 'subTab',
                        subTabs: [
                            {
                                id: '1',
                                label: 'Station 1',
                                content: [
                                    {
                                        id: 'no-of-mobiles',
                                        label: 'No of Mobile(s)',
                                        type: 'text'
                                    },
                                    {
                                        id: 'mobiles-communicate-with',
                                        label: 'Mobile(s) Communicate With',
                                        type: 'lists'
                                    },
                                    {
                                        id: 'coverage-information',
                                        label: 'Coverage Information',
                                        type: 'lists'
                                    },
                                    {
                                        id: 'latitude',
                                        label: 'Latitude (N)',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'latitude-degrees',
                                        label: 'Latitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-minutes',
                                        label: 'Latitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'latitude-seconds',
                                        label: 'Latitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude',
                                        label: 'Longitude (E)',
                                        type: 'subsection'
                                    },
                                    {
                                        id: 'longitude-degrees',
                                        label: 'Longitude Degrees',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-minutes',
                                        label: 'Longitude Minutes',
                                        type: 'text'
                                    },
                                    {
                                        id: 'longitude-seconds',
                                        label: 'Longitude Seconds',
                                        type: 'text'
                                    },
                                    {
                                        id: 'mobile-station-frequency-info',
                                        label: 'Frequency Information (Mobile Station)',
                                        type: 'subsection',
                                        fieldlist: [
                                            {
                                                id: 'mobile-station-frequency-info-table',
                                                label: '',
                                                type: 'table',
                                                subFields: [
                                                    {
                                                        id: 'manufacturer',
                                                        header: 'Manufacturer',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'model',
                                                        header: 'Model',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-from-tx',
                                                        header: 'Desired Frequency (MHz) - From (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-to-tx',
                                                        header: 'Desired Frequency (MHz) - To (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-from-rx',
                                                        header: 'Desired Frequency (MHz) - From (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'desired-frequency-mhz-to-rx',
                                                        header: 'Desired Frequency(MHz) - To (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'bandwidth-khz-tx',
                                                        header: 'Bandwidth (kHz) (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'bandwidth-khz-rx',
                                                        header: 'Bandwidth (kHz) (Rx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'emission-class-tx',
                                                        header: 'Emission Class (Tx)',
                                                        type: 'text'
                                                    },
                                                    {
                                                        id: 'emission-class-rx',
                                                        header: 'Emission Class (Rx)',
                                                        type: 'text'
                                                    }
                                                ]
                                            },
                                            {
                                                id: 'mobile-station-frequency-info-accordion',
                                                label: '',
                                                type: 'accordion',
                                                subFields: []
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
